(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6036],{

/***/ 35035:
/***/ (function(module) {

"use strict";


module.exports = function (data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = { cmp: opts };
    var cycles = (typeof opts.cycles === 'boolean') ? opts.cycles : false;

    var cmp = opts.cmp && (function (f) {
        return function (node) {
            return function (a, b) {
                var aobj = { key: a, value: node[a] };
                var bobj = { key: b, value: node[b] };
                return f(aobj, bobj);
            };
        };
    })(opts.cmp);

    var seen = [];
    return (function stringify (node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') {
            node = node.toJSON();
        }

        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);

        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for (i = 0; i < node.length; i++) {
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }

        if (node === null) return 'null';

        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }

        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for (i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = stringify(node[key]);

            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    })(data);
};


/***/ }),

/***/ 20337:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[urlKey]/pag",
      function () {
        return __webpack_require__(17848);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 94512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./lib/structuredData.js
var structuredData = __webpack_require__(89229);
;// CONCATENATED MODULE: ./components/BreadcrumbSchema.js




var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, baseUrl = _publicRuntimeConfig.settings.baseUrl;
var BreadcrumbSchema = function(param) {
    var breadcrumbData = param.breadcrumbData, currentPath = param.currentPath;
    // Do not include home page
    // Do not include pages without parent
    if (breadcrumbData && breadcrumbData.length > 1) {
        var itemListElement = breadcrumbData.map(function(breadcrumb, index) {
            return {
                "@type": "ListItem",
                position: index + 1,
                name: breadcrumb.name,
                item: breadcrumb.level != 99 ? "".concat(baseUrl, "/").concat(breadcrumb.url_key).concat(breadcrumb.url_suffix || "") : "".concat(baseUrl).concat(currentPath)
            };
        });
        var schema = {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: itemListElement
        };
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: (0,structuredData/* default */.Z)(schema)
            }
        }));
    }
    return null;
};
/* harmony default export */ var components_BreadcrumbSchema = (BreadcrumbSchema);

;// CONCATENATED MODULE: ./components/Breadcrumbs.js








var Breadcrumbs_ref = (0,config["default"])(), settings = Breadcrumbs_ref.publicRuntimeConfig.settings;
var isBricoStore = settings.websiteName === "bricostore";
var Breadcrumbs = function(param) {
    var breadcrumbs = param.breadcrumbs, _isPDP = param.isPDP, isPDP = _isPDP === void 0 ? false : _isPDP, className = param.className;
    var router = (0,next_router.useRouter)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            breadcrumbs && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BreadcrumbSchema, {
                breadcrumbData: breadcrumbs,
                currentPath: router.asPath
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "Breadcrumbs is-hidden-in-mobile-app pb-3 lg:py-3 truncate text-sm ".concat(className),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                    className: "p-0 m-0 list-none inline",
                    children: breadcrumbs.map(function(breadcrumb, index) {
                        return breadcrumb.level != 99 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: classnames_default()("inline", {
                                "text-red-brand": isBricoStore || !isPDP,
                                "text-[#1D4ED8]": !isBricoStore && isPDP
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "".concat(settings.baseUrl, "/").concat(breadcrumb.url_key).concat(breadcrumb.url_suffix || ""),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        title: breadcrumb.name,
                                        className: classnames_default()({
                                        }),
                                        children: breadcrumb.name
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mx-1",
                                    children: "/"
                                })
                            ]
                        }, "".concat(breadcrumb.level, "-").concat(breadcrumb.id, "-").concat(index)) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "inline",
                            children: breadcrumb.name
                        }, "".concat(breadcrumb.level, "-").concat(breadcrumb.id, "-").concat(index));
                    })
                })
            })
        ]
    }));
};
Breadcrumbs.propTypes = {
    breadcrumbs: prop_types_default().arrayOf(prop_types_default().shape({
        id: (prop_types_default()).number.isRequired,
        level: (prop_types_default()).number.isRequired,
        name: (prop_types_default()).string.isRequired,
        url_key: function(props, propName) {
            if (props["level"] !== 99 && (typeof props[propName] !== "string" || props[propName].length === 0)) {
                return new Error("Please provide url_key when item level is not 99.");
            }
        },
        url_suffix: (prop_types_default()).string
    })).isRequired
};
/* harmony default export */ var components_Breadcrumbs = (Breadcrumbs);


/***/ }),

/***/ 71662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var InputCheckbox = function(props) {
    var input = props.input, _meta = props.meta, touched = _meta.touched, error = _meta.error, visited = _meta.visited;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: "flex ".concat(props.className ? props.className : "", " ").concat(props.disabled ? "disabled" : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", _objectSpread({}, input, {
                        type: "checkbox",
                        required: props.required,
                        disabled: props.disabled,
                        className: "checkbox-input opacity-0 w-0 h-0 ".concat(touched && error ? "error" : "")
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "checkbox-control flex-none w-5 h-5 p-1 mr-2 border-gray-light border rounded-4px bg-white ".concat(props.required ? "is-required" : ""),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                            className: "",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                            "aria-hidden": "true",
                            focusable: "false",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "3",
                                d: "M1.73 12.91l6.37 6.37L22.79 4.59"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "block Form-label label ".concat(props.spanClassName, " ").concat(props.required ? "is-required" : ""),
                        children: typeof props.label === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: props.label
                            }
                        }) : props.label
                    })
                ]
            }),
            props.required && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: visited && error ? "" : "hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-red-brand text-sm",
                    children: error
                })
            })
        ]
    }));
};
InputCheckbox.defaultProps = {
    required: undefined,
    disabled: undefined
};
/* harmony default export */ __webpack_exports__["Z"] = (InputCheckbox);


/***/ }),

/***/ 61167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);



function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var withRouterPageLayout = function(ComposedComponent) {
    var WithRouteWrapper = /*#__PURE__*/ function(Component1) {
        "use strict";
        _inherits(WithRouteWrapper, Component1);
        var _super = _createSuper(WithRouteWrapper);
        function WithRouteWrapper() {
            _classCallCheck(this, WithRouteWrapper);
            return _super.apply(this, arguments);
        }
        _createClass(WithRouteWrapper, [
            {
                key: "render",
                value: function render() {
                    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ComposedComponent, _objectSpread({
                        router: this.context.router
                    }, this.props)));
                }
            }
        ]);
        return WithRouteWrapper;
    }(react__WEBPACK_IMPORTED_MODULE_1__.Component);
    _defineProperty(WithRouteWrapper, "contextTypes", {
        router: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().object)
    });
    WithRouteWrapper.getInitialProps = ComposedComponent.getInitialProps;
    // Hoists non standard static properties
    WithRouteWrapper.pageLayout = ComposedComponent.pageLayout;
    WithRouteWrapper.layoutProps = ComposedComponent.layoutProps;
    WithRouteWrapper.pageName = ComposedComponent.pageName;
    return WithRouteWrapper;
};
/* harmony default export */ __webpack_exports__["Z"] = (withRouterPageLayout);


/***/ }),

/***/ 89229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35035);
/* harmony import */ var fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0__);

// JSON-LD blocks are injected with dangerouslySetInnerHTML, so a "<" coming
// from product data (a "</script>" inside a product name or description) would
// close the script element early and make the whole block unparsable for
// crawlers, besides letting the markup run in the browser. These characters
// are only ever part of JSON string values, where the escaped form is
// equivalent, so escaping them keeps the JSON valid and the page safe.
var HTML_UNSAFE_ESCAPES = {
    "<": "\\u003c",
    ">": "\\u003e",
    "&": "\\u0026"
};
var serializeSchema = function(schema) {
    return fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0___default()(schema).replace(/[<>&]/g, function(character) {
        return HTML_UNSAFE_ESCAPES[character];
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (serializeSchema);


/***/ }),

/***/ 17848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11752);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26209);
/* harmony import */ var _components_withRouterPageLayout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61167);
/* harmony import */ var _containers_ErrorPage__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75720);
/* harmony import */ var _store_pages_actions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94308);
/* harmony import */ var _components_Breadcrumbs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(94512);
/* harmony import */ var _components_ContentEditorView_index__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(51961);











function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_4__["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, websiteTitle = _publicRuntimeConfig.content.websiteTitle, websiteName = _publicRuntimeConfig.settings.websiteName;
var Page = /*#__PURE__*/ function(Component1) {
    "use strict";
    _inherits(Page, Component1);
    var _super = _createSuper(Page);
    function Page() {
        _classCallCheck(this, Page);
        return _super.apply(this, arguments);
    }
    _createClass(Page, [
        {
            key: "render",
            value: function render() {
                var pageRes = this.props.pageRes;
                if (!pageRes) {
                    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_containers_ErrorPage__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        layout: "404"
                    }));
                }
                var parsedEditorContent;
                if (pageRes.content_object && pageRes.content_object.length > 10) {
                    try {
                        parsedEditorContent = JSON.parse(pageRes.content_object);
                    } catch (error) {
                        parsedEditorContent = false;
                    }
                }
                var fullWidthContainer = {
                    left: "50%",
                    right: "50%",
                    marginLeft: "-50vw",
                    marginRight: "-50vw",
                    width: "100vw",
                    position: "relative"
                };
                return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(next_head__WEBPACK_IMPORTED_MODULE_3__["default"], {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
                                    children: pageRes && pageRes.title || websiteTitle
                                }),
                                !!pageRes.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                                    name: "description",
                                    content: pageRes.description
                                }),
                                !!pageRes.keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                                    name: "keywords",
                                    content: pageRes.keywords
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Breadcrumbs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            breadcrumbs: [
                                {
                                    id: 1,
                                    level: 99,
                                    name: pageRes.title
                                }, 
                            ]
                        }),
                        pageRes.content_heading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                            className: websiteName === "bricostore" ? "bd-display2" : "",
                            children: pageRes.content_heading
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            style: pageRes.template === "empty" ? fullWidthContainer : null,
                            children: parsedEditorContent ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_ContentEditorView_index__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                content: parsedEditorContent
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                children: pageRes.content && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "Cms",
                                    dangerouslySetInnerHTML: {
                                        __html: pageRes.content
                                    }
                                })
                            })
                        })
                    ]
                }));
            }
        }
    ], [
        {
            key: "getInitialProps",
            value: function getInitialProps(ctx) {
                return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var reduxStore, query, res, urlAsPath, pageRes;
                    return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                reduxStore = ctx.reduxStore, query = ctx.query, res = ctx.res, urlAsPath = ctx.asPath;
                                _ctx.next = 3;
                                return reduxStore.dispatch((0,_store_pages_actions__WEBPACK_IMPORTED_MODULE_8__/* .getPage */ .f)(query.urlKey));
                            case 3:
                                pageRes = _ctx.sent;
                                if (!pageRes) {
                                    if (res) {
                                        res.statusCode = 404;
                                    }
                                }
                                return _ctx.abrupt("return", {
                                    urlAsPath: urlAsPath,
                                    pageRes: pageRes,
                                    query: query
                                });
                            case 6:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        }
    ]);
    return Page;
}(react__WEBPACK_IMPORTED_MODULE_2__.Component);
Page.pageLayout = "default";
/* harmony default export */ __webpack_exports__["default"] = ((0,_components_withRouterPageLayout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .connect */ .$j)(null, {
    getPage: _store_pages_actions__WEBPACK_IMPORTED_MODULE_8__/* .getPage */ .f
})(Page)));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1423,5866,1961,9774,2888,179], function() { return __webpack_exec__(20337); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);